module.exports =
  '_HISTORY':
    'TITLE': 'ヒストリ'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/history/i18n/ja.coffee